<template>
  <b-card header="Share Ekey">
    <b-form id="edit-ekey-form">
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Name</b-input-group-text></b-input-group-prepend>
          <b-form-input type="text" v-model="formData.name" placeholder="name" disabled="true"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-user"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Email</b-input-group-text></b-input-group-prepend>
          <b-form-input type="text" v-model="formData.email" placeholder="email" disabled="true"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-at"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Phone</b-input-group-text></b-input-group-prepend>
          <b-form-input type="text" v-model="formData.phone" placeholder="phone" disabled="true"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-phone"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Start Date</b-input-group-text></b-input-group-prepend>
          <b-form-input type="date" id="startDate" format="YYYY-MM-DD HH:mm:ss" v-model="formData.startDate" placeholder="StartDate"></b-form-input>
          <b-form-input type="time" id="startTime" v-model="formData.startTime"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>End Date</b-input-group-text></b-input-group-prepend>
          <b-form-input type="date" id="endDate" v-model="formData.endDate" placeholder="EndDate"></b-form-input>
          <b-form-input type="time" id="endTime" v-model="formData.endTime"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
        </b-form-group>

        <div class="form-group form-actions">
          <b-button @click="submitData($event.target)" type="button" size="sm" variant="primary">Save</b-button>
        </div>
    </b-form>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_EDIT = BASE + '/api/keys/edit'
const API_LIST = BASE + '/api/locks/listGuest'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

function postEditData (url, data, lockId, keyId) {
  var partsStartDate = data.startDate.split('-')
  var partsEndDate = data.endDate.split('-')
  var partStartTime = data.startTime.split(':')
  var partEndTime = data.endTime.split(':')
  data.startDate = new Date(partsStartDate[0], partsStartDate[1] - 1, partsStartDate[2], partStartTime[0], partStartTime[1]).getTime()
  data.endDate = new Date(partsEndDate[0], partsEndDate[1] - 1, partsEndDate[2], partEndTime[0], partEndTime[1]).getTime()
  data.lockId = lockId

  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getListData (lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId,
    pageSize: 25
  }
  let res = await postdata(API_LIST, parameters)
  let result = res.list
  return result
}

export default {
  name: 'ekey-edit-form',
  data () {
    // var now = new Date()
    // var hour =  (now.getHours() < 10) ? '0' + now.getHours() : now.getHours()
    // var min = (now.getMinutes() < 10) ? '0' + now.getMinutes() : now.getMinutes()
    // var timeNow = hour + ':' + min
    return {
      key: this.ekey,
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: '',
        email: '',
        name: '',
        phone: '',
        startDate: '',
        endDate: '',
        keyId: this.ekeyId,
        username: '',
        endTime: '',
        startTime: ''
      }
    }
  },
  mounted () {
    this.$data.formData.startDate = constants.getToday()
    this.$data.formData.endDate = constants.getEndDate()
    this.$data.formData.startTime = constants.getTimeNow()
    this.$data.formData.endTime = constants.getTimeNow()

    this.$data.formData.name = this.$data.key.name
    this.$data.formData.email = this.$data.key.email
    this.$data.formData.phone = this.$data.key.username
    this.$data.formData.username = this.$data.key.username
  },
  props: ['locationName', 'locationId', 'locationDescription', 'lockId', 'ekeyId', 'modalId', 'ekey'],
  methods: {
    submitData (button) {
      let lockId = this.$route.params.lockId
      postEditData(API_EDIT, this.formData, lockId)
        .then(data => {
          getListData(lockId).then(dataList => {
            this.$root.$emit('ekeylist', dataList)
            this.formData.startdate = constants.getToday()
            this.formData.enddate = constants.getEndDate()
            this.formData.startTime = constants.getTimeNow()
            this.formData.endTime = constants.getTimeNow()
            this.$root.$emit('bv::hide::modal', this.modalId, button)
          })
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/EkeyEditForm.vue